import { createContext, useState } from 'react'

export const SpotlightSearchContext = createContext({ searchOpen: false, setSearchOpen: (...args) => {} })

export const SpotlightSearchContextProvider = ({ children }) => {
  const [searchOpen, setSearchOpen] = useState(false)

  return (
    <SpotlightSearchContext.Provider value={{ searchOpen, setSearchOpen }}>{children}</SpotlightSearchContext.Provider>
  )
}
